window["CP_MS_PDP_06_V1"] = function () {
    const container = document.querySelector(".CP-carousel-container");
    if (!container) return;

    const track = container.querySelector(".CP-carousel-track");
    const dotsContainer = container.querySelector(".CP-carousel-dots");
    const slides = Array.from(track.querySelectorAll(".CP-carousel-card"));

    const playIconSVG = `<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" fill="#e3e3e3"><path d="m380-300 280-180-280-180v360Z"></path></svg>`;
    const pauseIconSVG = `<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" fill="#e3e3e3"><path d="M360-320h80v-320h-80v320Zm160 0h80v-320h-80v320Z"></path></svg>`;

    let slidesPerView = getSlidesPerView();
    let currentIndex = slidesPerView; // start after clones
    let isAnimating = false;

    function getSlidesPerView() {
        if (window.innerWidth >= 1024) return 5;
        if (window.innerWidth >= 768) return 3;
        return 2;
    }


    // Pause all videos
    function pauseAllVideos() {
        allSlides.forEach(slide => {
            const video = slide.querySelector("video");
            const btn = slide.querySelector(".CP-play-btn");
            if (video && !video.paused) video.pause();
            if (btn) btn.innerHTML = playIconSVG;
        });
    }

    function forceLoadVideo(video) {
        if (video && video.dataset.src && !video.src) {
            video.src = video.dataset.src;
            video.load();
        }
    }

    function lazyLoadVideos() {
        const videoWrappers = track.querySelectorAll("video[data-src]");
        const observer = new IntersectionObserver(
            (entries, obs) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        forceLoadVideo(entry.target);
                        obs.unobserve(entry.target);
                    }
                });
            },
            { root: null, threshold: 0.5 }
        );
        videoWrappers.forEach(video => observer.observe(video));
    }

    // Clone slides for multi-slide loop
    let allSlides = [];
    function cloneSlides() {
        slidesPerView = getSlidesPerView();

        // Remove old clones
        track.querySelectorAll(".clone").forEach(clone => clone.remove());

        // Clone last N slides to start
        const lastSlides = slides.slice(-slidesPerView).map(slide => {
            const clone = slide.cloneNode(true);
            clone.classList.add("clone");
            track.insertBefore(clone, track.firstChild);
            return clone;
        });

        // Clone first N slides to end
        const firstSlides = slides.slice(0, slidesPerView).map(slide => {
            const clone = slide.cloneNode(true);
            clone.classList.add("clone");
            track.appendChild(clone);
            return clone;
        });

        allSlides = Array.from(track.querySelectorAll(".CP-carousel-card"));
        currentIndex = slidesPerView; // reset index after cloning
    }

    function updateCarousel(transition = true) {
        const cardWidth = container.offsetWidth / slidesPerView;
        allSlides.forEach(slide => slide.style.minWidth = `${cardWidth}px`);

        const translateX = -currentIndex * cardWidth;
        track.style.transition = transition ? "transform 0.4s ease" : "none";
        track.style.transform = `translateX(${translateX}px)`;

        // preload visible videos
        for (let i = currentIndex; i < currentIndex + slidesPerView; i++) {
            forceLoadVideo(allSlides[i]?.querySelector("video"));
        }

        // Update dots for real slides only
        const realSlidesCount = slides.length;
        let dotIndex = currentIndex - slidesPerView;
        if (dotIndex < 0) dotIndex = realSlidesCount - 1;
        if (dotIndex >= realSlidesCount) dotIndex = 0;

        dotsContainer.innerHTML = "";
        slides.forEach((_, i) => {
            const dot = document.createElement("span");
            dot.className = "CP-dot" + (i === dotIndex ? " active" : "");
            dot.dataset.index = i + slidesPerView; // for jump
            dotsContainer.appendChild(dot);
        });
    }

    function moveSlide(step) {
        if (isAnimating) return;
        isAnimating = true;
        pauseAllVideos();
        currentIndex += step;
        updateCarousel(true);
    }

    // Handle infinite loop after transition
    track.addEventListener("transitionend", () => {
        const realSlidesCount = slides.length;
        if (currentIndex < slidesPerView) currentIndex = currentIndex + realSlidesCount;
        if (currentIndex >= allSlides.length - slidesPerView) currentIndex = currentIndex - realSlidesCount;
        updateCarousel(false);
        isAnimating = false;
    });

    // Arrow buttons
    const prevBtn = container.querySelector(".CP-prev");
    const nextBtn = container.querySelector(".CP-next");
    if (prevBtn) prevBtn.addEventListener("click", () => moveSlide(-1));
    if (nextBtn) nextBtn.addEventListener("click", () => moveSlide(1));

    // Dot click
    dotsContainer.addEventListener("click", (e) => {
        if (!e.target.classList.contains("CP-dot")) return;
        pauseAllVideos();
        currentIndex = Number(e.target.dataset.index);
        updateCarousel(true);
    });

    // Swipe
    let startX = 0;
    track.addEventListener("touchstart", (e) => startX = e.touches[0].clientX);
    track.addEventListener("touchend", (e) => {
        const endX = e.changedTouches[0].clientX;
        if (endX - startX > 50) moveSlide(-1);
        else if (startX - endX > 50) moveSlide(1);
    });

    // Play button toggle
    track.addEventListener("click", (e) => {
        const btn = e.target.closest(".CP-play-btn");
        if (!btn) return;
        const wrapper = btn.closest(".CP-video-wrapper");
        const video = wrapper.querySelector("video");
        if (!video) return;
        // Pause all sibling videos
        const allVideos = track.querySelectorAll(".CP-video-wrapper video");
        allVideos.forEach(v => {
            if (v !== video && !v.paused) {
                v.pause();  // Pause any video that is not the closest one
                const siblingBtn = v.closest(".CP-video-wrapper").querySelector(".CP-play-btn");
                if (siblingBtn) siblingBtn.innerHTML = playIconSVG;  // Revert the play icon of siblings
            }
        });
        // Play the clicked video's video
        if (video.paused) {
            video.play().then(() => btn.innerHTML = pauseIconSVG);  // Change play icon to pause
        } else {
            video.pause();
            btn.innerHTML = playIconSVG;  // Revert to play icon if video is paused
        }
    });


    // Pause videos when slider not visible
    const visibilityObserver = new IntersectionObserver(
        entries => { entries.forEach(entry => { if (!entry.isIntersecting) pauseAllVideos(); }); },
        { threshold: 0.7 }
    );
    visibilityObserver.observe(container);

    // Resize
    window.addEventListener("resize", () => {
        slidesPerView = getSlidesPerView();
        cloneSlides();
        updateCarousel(false);
    });

    lazyLoadVideos();
    cloneSlides();
    updateCarousel(false);
};

window.CP_MS_PDP_06_V1();